import initiateWeatherPullTaskOnCalendar from 'owa-weather-option/lib/data/actions/initiateWeatherPullTaskOnCalendar';
import weatherPullTask from '../actions/weatherPullTask';
import { createLazyOrchestrator } from 'owa-bundling';

/**
 * The actions for updating weather settings options are defined in options package
 * Since we don't invoke it directly, we need to use a lazy orchestrator to update weather (mainly the temperature unit)
 * whenever those actions are executed.
 */
export const initiateWeatherPullTaskOnCalendarOrchestrator = createLazyOrchestrator(
    initiateWeatherPullTaskOnCalendar,
    'CLONE_INITIATE_WEATHER_PULL_TASK_ON_CALENDAR',
    () => {
        weatherPullTask();
    }
);
